import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import Spinner from '../../../../components/global/Spinner';
import CustomPrintConfigurator from '../../../../components/global/CustomPrintConfigurator';
import CustomPrintConfigNavigationModal from './CustomPrintConfigNavigationModal';
import { postNativeAppCustomConfiguratorComplete } from '../../../../services/native-bridge/native-apps-interface';

class CustomPrintConfiguratorManager extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    albumCustomPrint: PropTypes.object,
    candidatePhotoGroups: PropTypes.array,
    pendingPurchasedCustomPrints: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
      }),
    ),
    customPrintUpdate: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    path: PropTypes.string.isRequired,
    openModal: PropTypes.func,
    onComplete: PropTypes.func,
    renderSuccess: PropTypes.func,
  };

  static defaultProps = {
    onComplete: () => {},
  };

  state = {
    completed: false,
    next: false,
  };

  componentDidMount() {
    if (window && window.scrollTo) {
      window.scrollTo(0, 0);
    }
  }

  onCustomPrintUpdated = () => {
    const { pendingPurchasedCustomPrints } = this.props;
    const [nextPurchasedCustomPrint] = pendingPurchasedCustomPrints;

    if (nextPurchasedCustomPrint) {
      this.setState(() => ({
        next: true,
        completed: false,
      }));
    } else {
      this.onFinishConfiguration();
    }
  };

  onNextCustomPrint = () => {
    const { pendingPurchasedCustomPrints, history, path } = this.props;
    const [nextPurchasedCustomPrint] = pendingPurchasedCustomPrints;

    this.setState(
      () => ({
        next: false,
        completed: false,
      }),
      () => {
        history.replace(`${path}/${nextPurchasedCustomPrint.id}`);
      },
    );
  };

  onFinishConfiguration = () => {
    const { onComplete } = this.props;

    this.setState(
      () => ({
        completed: true,
        next: false,
      }),
      () => {
        onComplete();
        postNativeAppCustomConfiguratorComplete();
      },
    );
  };

  onCustomPrintUpdate = async ({
    albumCustomPrint,
    caption,
    photos,
    address,
  }) => {
    const { customPrintUpdate } = this.props;

    const { data } = await customPrintUpdate({
      id: albumCustomPrint.id,
      caption: albumCustomPrint.custom_print_caption_enabled ? caption : '',
      photos,
      placeOrder: true,
      address,
    });

    return data;
  };

  render() {
    const { completed, next } = this.state;
    const {
      loading,
      albumCustomPrint,
      candidatePhotoGroups,
      pendingPurchasedCustomPrints,
      openModal,
      renderSuccess,
    } = this.props;

    if (loading || !albumCustomPrint) {
      return (
        <div className="text-center my-3">
          <Spinner />
        </div>
      );
    }

    return (
      <Fragment>
        <CustomPrintConfigurator
          key={albumCustomPrint.id}
          loading={loading}
          completed={completed}
          albumCustomPrint={albumCustomPrint}
          onSubmit={this.onCustomPrintUpdate}
          onSubmitSuccess={this.onCustomPrintUpdated}
          openModal={openModal}
          renderSuccess={renderSuccess}
          candidatePhotoGroups={candidatePhotoGroups}
        />

        <CustomPrintConfigNavigationModal
          forceOpen={!completed && next}
          onClose={this.onFinishConfiguration}
          pendingPurchasedCustomPrints={pendingPurchasedCustomPrints}
          onNextCustomPrint={this.onNextCustomPrint}
        />
      </Fragment>
    );
  }
}

export default CustomPrintConfiguratorManager;
